export default "__VITE_ASSET__DlPYfp43__"